import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@rd/core/auth/guards/auth.guard';
import { BenefitPromptGuard } from './core/guards/benefit-prompt.guard.service';
import { StarNoticeModalGuard } from './core/guards/notice-modal.guard.service';
import { StarHomePageComponent } from './core/views/home-page/home-page.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    component: StarHomePageComponent,
    canActivate: [BenefitPromptGuard, StarNoticeModalGuard],
  },
  {
    path: 'select-carrier',
    loadChildren: () =>
      import('./select-carrier/select-carrier.module').then(
        (m) => m.SelectCarrierModule,
      ),
    canActivate: [AuthGuard, StarNoticeModalGuard],
  },
  {
    path: 'points_activity',
    loadChildren: () =>
      import('./points-transaction/points-transaction-wrapper.module').then(
        (m) => m.PointsTransactionWrapperModule,
      ),
    canActivate: [BenefitPromptGuard, StarNoticeModalGuard],
  },
  {
    path: 'transfer',
    loadChildren: () =>
      import('./transfer-connect-v2/transfer-connect-v2-wrapper.module').then(
        (m) => m.TransferConnectV2WrapperModule,
      ),
    canActivate: [BenefitPromptGuard, StarNoticeModalGuard],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      initialNavigation: 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
